// extracted by mini-css-extract-plugin
export default {"Sidebar":"Sidebar_Sidebar__EnVR5","Active":"Sidebar_Active__F6kte","Burger":"Sidebar_Burger__H7xSj"};